import React from "react";
import styled from "styled-components";
import footimage from "../../assets/Group 33.png";
import { FaInstagram } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { SiPinboard } from "react-icons/si";
import { IoMdNavigate } from "react-icons/io";
import { AiOutlineCopyright } from "react-icons/ai";
import { FiPhoneCall } from "react-icons/fi";
import { SlLocationPin } from "react-icons/sl";
import image8 from "../../assets/CD Game Portfolio (5) 1.png";
import image9 from "../../assets/bgFooter.png";
import image10 from "../../assets/CODENARY DEVS.png";
import image11 from "../../assets/Untitled design (15) 1.png";
import image12 from "../../assets/fb 1.png";
import image13 from "../../assets/insta.png";
import image14 from "../../assets/notification (1) 1.png";
import image15 from "../../assets/x.png";
import image16 from "../../assets/fb.png";
import image17 from "../../assets/notification 1.png";

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;
const RedLocationPin = styled(SlLocationPin)`
  color: red;
  @media screen and (max-width: 600px) {
    font-size: 1.5rem;
    margin: 0px;
  }
`;
const ContanierFoot = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${image9});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
  @media screen and (max-width: 600px) {
    height: 950px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    height: 970px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    height: 500px;
  }
`;
const ContanierLogo = styled.div`
  width: 100%;
  /* display: flex; */
  height: 70px;
`;
const ContanierColum = styled.div`
  width: 100%;
  /* background-color:red; */
  padding-left: 140px;
  margin-top: 10px;
  height: 260px;
  display: flex;
  gap: 10px;
  box-sizing: border-box;
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    padding: 0px;
    margin-top: 0%;
    /* background-color: red; */
    height: 690px;
    gap: 0px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    padding: 0px;
    /* background-color: red;; */
    height: 880px;
    gap: 0px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    padding: 10px;
    height: 400px;
    padding-left: 30px;
    padding-top: 50px;
    margin-top: 30px;
  }
`;

const ContanierOne = styled.div`
  color: white;
  width: 30%;
  margin-top: 40px;
  /* background-color: green; */
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    line-height: 25px;
    width: 100%;
    margin-top: 15px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    width: 33%;
    height: auto;
  }
`;

const ContanierTwo = styled.div`
  width: 30%;
  margin-top: 20px;
  color: white;
  padding: 15px;
  padding-left: 70px;
  /* background-color: #ff00bf; */
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 10px;
    align-items: center;
    text-align: center;
    padding-top: 0px;
    margin-top: 0px;
    padding-bottom: 0px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 10px;
    align-items: center;
    text-align: center;
    padding-bottom: 0px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
  }
`;
const ContanierThree = styled.div`
  width: 30%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  color: white;
  /* background-color: blue; */
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    text-align: center;
    padding-top: 0px;
    line-height: 22px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    text-align: center;
    padding-top: 0px;
    line-height: 22px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    width: 40%;
  }
`;
const FoorImage = styled.img`
  width: 80px;
  height: auto;
  padding-top: 15px;
  margin-left: 140px;

  @media screen and (max-width: 600px) {
    /* margin-left: 10px; */
    justify-content: center;
    align-items: center;
    display: flex;
    margin-left: 50%;
    transform: translateX(-50%);
    bottom: 20px;
position: relative;
/* z-index: 129; */
bottom: 100%;
    width: 20%;
    height: auto;
    padding-bottom: 0px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    margin-left: 30px;
    margin-top: 30px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    margin-left: 30px;
    margin-top: 30px;
  }
`;

const FoorImage1 = styled.img`
  width: 365px;
  height: auto;
  /* padding-top: 15px; */
  margin-left: 10px;
  margin-bottom: 20px;

  @media screen and (max-width: 600px) {
    /* margin-left: 10px; */
    justify-content: center;
    align-items: center;
    display: flex;
    margin-left: 50%;
    transform: translateX(-50%);
    position: relative;
    bottom: 50px;
    width: 305px;
    height: auto;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    margin-left: 30px;
    margin-top: 30px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    margin-left: 30px;
    margin-top: 30px;
  }
`;

const HeadText = styled.h1`
  font-size: 1.4rem;
  font-family: "Calistoga";
  margin: 10px;
  @media screen and (max-width: 600px) {
    font-size: 1.5rem;
    margin: 0px;
    /* margin-left: 10px; */
    margin-top: 8px;
  }
`;
const HeadText4 = styled.h1`
  font-size: 1.6rem;
  font-family: "Calistoga";
  margin: 10px;
  @media screen and (max-width: 600px) {
    font-size: 2rem;
    margin: 0px;
    margin-left: 10px;
    margin-top: 8px;
    margin-bottom: 30px;
  }
`;
const HeadText2 = styled.h1`
  font-size: 1.5rem;
  margin: 10px;
  color: #0fb6e9;
  font-weight: bold;
  font-family: "Calistoga";
  @media screen and (max-width: 600px) {
    font-size: 1rem;
    margin: 0px;
    /* margin-left: 10px; */
    margin-top: 8px;
  }
`;

const HeadText3 = styled.p`
  font-size: 1.3rem;
  margin: 10px;
  line-height: 0.3;
  @media screen and (max-width: 600px) {
    font-size: 1rem;
    margin: 0px;
    /* margin-left: 10px; */
    margin-top: 8px;
  }
`;
const ParaText = styled.p`
  font-size: 1rem;
  margin: 10px;

  @media screen and (max-width: 600px) {
    font-size: 1rem;
    margin: 0px;
    /* margin-left: 10px; */
    margin: 0px 30px 30px 30px;
  }
`;

const ParaText1 = styled.p`
  font-size: 1.5rem;
  margin: 10px;
  font-weight: bold;
  font-family: "Calistoga";
  @media screen and (max-width: 600px) {
    font-size: 1.5rem;
    margin: 0px 0px 0px 10px;
  }
`;
const HeadText1 = styled.h1`
  font-size: 1.7rem;
  color: #e9b60f;
  @media screen and (max-width: 600px) {
    margin-left: 30px;
    margin-top: 30px;
  }
`;

const InstagramIcon = styled(FaInstagram)`
  color: #fdfcfc; /* Instagram brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    color: #e1306c; /* Change color on hover */
    background-color: white;
  }
  @media screen and (max-width: 600px) {
    display: flex;
  }
`;
const TwitterIcon = styled(FaTwitter)`
  color: #f6f6f7; /* Twitter brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    background-color: white;
    color: #1da1f2; /* Change color on hover */
  }
  @media screen and (max-width: 600px) {
    display: flex;
  }
`;
const LinkedInIcon = styled(FaLinkedin)`
  color: #f5f7f8; /* LinkedIn brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    color: #0a66c2; /* Change color on hover */
    background-color: white;
  }
`;
const FacebookIcon = styled(FaFacebook)`
  /* background-color: white; */

  color: #fafafa; /* Facebook brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    background-color: white;
    color: #1877f2; /* Change color on hover */
  }
`;
const ScrollButton = styled.button`
  background-color: white;
  color: black;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1rem;
  position: absolute;
  bottom: 1rem;

  &:hover {
    background-color: black;
    color: white;
  }

  @media screen and (max-width: 600px) {
    margin-right: 60px;
    margin-bottom: 40px;
  }
`;
const FooterContainer = styled.footer`
  background-color: #363434;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: absolute;
  margin-left: 90%;
`;
const Icons = styled.div`
  width: 63%;
  height: 65px;
  border-radius: 10px;
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  @media screen and (max-width: 849px) {
    margin-top: 10px;
    margin-bottom: 30px;
    width: 70%;
  }
`;

const Contanier1Foot2 = styled.p`
  width: 100%;
  height: 70px;
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  justify-content: center;
  display: flex;
  background-color: #ffffff;
  color: #000000;
  @media screen and (max-width: 849px) {
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 1rem;
    height: 30px;
    padding: 10px;
    line-height: 1.5;
  }
  @media screen and (max-width: 600px) {
    font-size: 10px;
    height: 30px;
  }
`;
const HeadUnderLine = styled.p`
  text-decoration: underline;
`;

const IconImage = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 10px;
  margin-top: 10px;
  @media screen and (max-width: 600px) {
  }
`;
const QuoteButton = styled.button`
  display: inline-block;
  background-color: #00eeff;
  color: white;
  font-size: 20px;
  font-family: "Calistoga";
  font-weight: bold;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: #06acb8;
    color: #ffffff;
  }
`;

const IconsLinks = styled.a``;

const IstagramImage = styled.img`
  width: 50px;
  height: 50px;
  /* margin-top: 10px; */
  @media screen and (max-width: 600px) {
  }
`;

const LinkedINIconImage = styled.img`
  width: 50px;
  height: 50px;
  /* margin-right: 10px; */
  /* margin-top: 10px; */
`;
const TwitterIconImage = styled.img`
  width: 50px;
  height: 50px;
  /* margin-right: 10px; */
  /* margin-top: 10px; */
`;

const FacebookIconImage = styled.img`
  width: 50px;
  height: 50px;
  /* margin-right: 10px; */
  /* margin-top: 10px; */
`;

const SiPinboardImage = styled.img`
  width: 18px;
  height: 18px;
  /* margin-right: 10px; */
  /* margin-top: 10px; */
`;

const Footer = () => {
  const handleScrollToNavbar = () => {
    document.querySelector("nav").scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <Wrap>
        <ContanierFoot>
          <ContanierLogo>
            <FoorImage src={footimage} alt="Foot Image Not Found" />
            <FoorImage1 src={image10} alt="Foot Image Not Found" />
          </ContanierLogo>
          <ContanierColum>
            <ContanierTwo>
              <HeadText>Home</HeadText>
              <HeadText>About Us</HeadText>
              <HeadText2>Our Services</HeadText2>
              <HeadText3>
                <IconImage src={image11} alt="Icon Image Not Found" />
                Mobile Apps
              </HeadText3>
              <HeadText3>
                <IconImage src={image11} alt="Icon Image Not Found" />
                Websites
              </HeadText3>
              <HeadText3>
                <IconImage src={image11} alt="Icon Image Not Found" />
                Games
              </HeadText3>
            </ContanierTwo>

            <ContanierOne>
              <HeadText>
                <RedLocationPin /> Canada:
              </HeadText>
              <ParaText>
                Address: 12 Divinity Circle, Brampton L7A3Y4, Ontario
              </ParaText>
              <HeadText>
                <RedLocationPin /> Pakistan:
              </HeadText>
              <ParaText>
                Address: Suit #5, Ground Floor, 69-B-2 Al- Hafeez suits, Gulberg
                3, Lahore.
              </ParaText>
            </ContanierOne>

            <ContanierThree>
              <HeadText4>Contact us today to</HeadText4>
              <ParaText>
                <QuoteButton
                  onClick={() => (window.location.href = "/ContactUs")}
                >
                  Get a Quote
                </QuoteButton>
              </ParaText>
              <ParaText1>Social Media</ParaText1>

              <Icons>
                <IconsLinks
                  href="http://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IstagramImage
                    src={image13}
                    alt="not found instagram image"
                  />
                </IconsLinks>

                <IconsLinks
                  href="http://google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedINIconImage
                    src={image14}
                    alt="Twitter image not found"
                  />
                </IconsLinks>

                <IconsLinks
                  href="https://www.linkedin.com/company/big-heap-tech/mycompany/?viewAsMember=true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TwitterIconImage
                    src={image16}
                    alt="Twitter image not found"
                  />
                </IconsLinks>

                <IconsLinks
                  href="https://www.facebook.com/people/Big-Heap-Technologies/100089626863409/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIconImage
                    src={image15}
                    alt="Facebook Image not found"
                  />
                </IconsLinks>
              </Icons>
              <ParaText>
                <SiPinboardImage src={image17} alt="email image not found" />{" "}
                <b>info@codenarydevs.com</b>
              </ParaText>
            </ContanierThree>
          </ContanierColum>
        </ContanierFoot>
        <Contanier1Foot2>
          Copyright <AiOutlineCopyright /> &nbsp; 2022 Developed by &nbsp;{" "}
          <HeadUnderLine> codenarydevs.com</HeadUnderLine>. &nbsp; All Rights
          Reserved.
        </Contanier1Foot2>
      </Wrap>
    </>
  );
};

export default Footer;
